

export const SwitchToggle = ({valor, keyEdit, setEdit}) => {
    // console.log('valor',valor,'key ',key,'setEdit',setEdit)
    const changeToggle = (event) => {
        const isChecked = event.target.checked;
        keyEdit  ? setEdit(keyEdit, isChecked) : setEdit(isChecked)
    }
    return(
        <>
            <label className="switch">
                <input
                    type="checkbox"
                    onChange={changeToggle}
                    checked={valor}
                />
                <span className="slider round"></span>
            </label>
        </>
    )
}